import { formatTokenAmountCompact } from 'utils/FormatNumber';

interface Props {
  title: string;
  value?: number;
  suffix?: string;
}

const InfoBox = ({ title, value, suffix }: Props) => {
  return (
    <div className="flex justify-center xxs:mb-2 items-center xxs:py-4">
      <div className="text-center">
        <div className="text-3xl font-medium">
          {formatTokenAmountCompact(value ?? 0)} {suffix ?? ''}
        </div>
        <div>{title}</div>
      </div>
    </div>
  );
};

export default InfoBox;
